import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=b0e9dfa4&scoped=true&"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=b0e9dfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e9dfa4",
  null
  
)

export default component.exports